import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-connection-banner',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule],
  templateUrl: './connection-banner.component.html',
  host: {
    class: 'block w-full shrink-0',
  },
})
export class ConnectionBannerComponent {}
